import React, { useContext, useEffect, useState } from "react";
import "./style.css";
import { Camera, Diamonds, Timer1 } from "iconsax-react";
import { MDBBtn, MDBInput } from "mdb-react-ui-kit";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import profilePic from "../../assets/images/img_1.png";
import profileCircle from "../../assets/images/profile-circle.png";
import { getAllUserInfo } from "../../Store/UserAction";
import { api } from "../../utils/axios";
import { UserContext } from "../../utils/context/userContext";
import UserProfile from "../home/userProfile";

function EditProfile() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const userDetail = useSelector((state) => state.user.data);
	const [values, setValues] = useState(userDetail.user);
	const [disableBtn, setDisableBtn] = useState(false);
	const [pass, setPass] = useState({
		oldPass: "",
		newPass: "",
		confirmNewPass: "",
	});
	const [subscriptions, setSubscriptions] = useState([]);
	const [loadingSubscriptions, setLoadingSubscriptions] = useState(true);
	const [uploadingImage, setUploadingImage] = useState(false);
	const [selectedImage, setSelectedImage] = useState(null);
	const [imagePreview, setImagePreview] = useState(null);
	const [buyingPlanId, setBuyingPlanId] = useState(null);
	const [selectedDuration, setSelectedDuration] = useState("monthly");

	const [discountAvailable, setDiscountAvailable] = useState(false);

	const handleBuyPlan = async (plan) => {
		try {
			setBuyingPlanId(plan.id);

			const token = localStorage.getItem("token"); // JWT

			const res = await fetch("/api/buy_subscription", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify({ subscription_id: plan.id }),
			});

			if (!res.ok) {
				const err = await res.json().catch(() => ({}));
				console.error("Buy subscription error:", err);
				alert(err.error || "خطا در ایجاد پرداخت");
				setBuyingPlanId(null);
				return;
			}

			const data = await res.json();

			if (!data.payment || !data.payment.token) {
				console.error("Invalid payment response:", data);
				alert("پاسخ نامعتبر از سرور پرداخت");
				setBuyingPlanId(null);
				return;
			}

			const payment = data.payment;

			// ---- Redirect to bank ----
			const form = document.createElement("form");
			form.method = "POST";
			form.action = payment.gateway_url; // e.g. https://sep.shaparak.ir/Payment.aspx

			const tokenInput = document.createElement("input");
			tokenInput.type = "hidden";
			tokenInput.name = "Token";
			tokenInput.value = payment.token;

			form.appendChild(tokenInput);
			document.body.appendChild(form);
			form.submit();
		} catch (error) {
			console.error(error);
			alert("مشکلی در ارتباط با سرور پرداخت پیش آمد");
			setBuyingPlanId(null);
		}
	};

	// Helper function to get profile picture with fallback
	const getProfilePicture = (userData, fallbackImage) => {
		if (userData?.profile_picture) {
			return userData.profile_picture;
		}
		return fallbackImage;
	};

	// Handle image selection
	const handleImageSelect = (event) => {
		const file = event.target.files[0];
		if (file) {
			// Validate file type
			if (!file.type.startsWith("image/")) {
				toast.error("لطفا یک فایل تصویری انتخاب کنید");
				return;
			}

			// Validate file size (max 5MB)
			if (file.size > 5 * 1024 * 1024) {
				toast.error("حجم فایل نباید بیشتر از 5 مگابایت باشد");
				return;
			}

			setSelectedImage(file);

			// Create preview
			const reader = new FileReader();
			reader.onload = (e) => {
				setImagePreview(e.target.result);
			};
			reader.readAsDataURL(file);
		}
	};

	// Handle image upload
	const handleImageUpload = async () => {
		if (!selectedImage) {
			toast.error("لطفا یک تصویر انتخاب کنید");
			return;
		}

		setUploadingImage(true);
		const formData = new FormData();
		formData.append("file", selectedImage);

		try {
			const token = localStorage.getItem("token");
			const response = await api.post("/upload_profile_picture", formData, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "multipart/form-data",
				},
			});

			toast.success("تصویر پروفایل با موفقیت آپلود شد");

			// Refresh user data to get updated profile picture
			dispatch(getAllUserInfo());

			// Clear selected image and preview
			setSelectedImage(null);
			setImagePreview(null);
		} catch (error) {
			if (error.response?.data?.error) {
				toast.error(error.response.data.error);
			} else {
				toast.error("خطا در آپلود تصویر");
			}
		} finally {
			setUploadingImage(false);
		}
	};

	// Fetch subscriptions from backend
	useEffect(() => {
		const fetchSubscriptions = async () => {
			try {
				const response = await api.get("/subscriptions", {
					headers: {
						Authorization: `Bearer ${localStorage.getItem("token")}`,
					},
				});

				// Expecting: { subscriptions: [...], first_time_discount_available: bool }
				setSubscriptions(response.data.subscriptions || []);
				setDiscountAvailable(
					response.data.first_time_discount_available || false,
				);
			} catch (error) {
				toast.error("خطا در دریافت اطلاعات اشتراک‌ها");
			} finally {
				setLoadingSubscriptions(false);
			}
		};

		fetchSubscriptions();
	}, []);

	function submitForm(e) {
		e.preventDefault();

		const data = {
			fname: values.fname,
			lname: values.lname,
		};

		if (pass.oldPass) data.current_password = pass.oldPass;
		if (pass.newPass) data.new_password = pass.newPass;
		if (pass.confirmNewPass) data.confirm_password = pass.confirmNewPass;
		if (values.role) data.role = values.role;

		// دریافت توکن و بررسی آن
		const token = localStorage.getItem("token");
		if (token) {
			const decodedToken = JSON.parse(atob(token.split(".")[1])); // Decode JWT
			const expirationDate = new Date(decodedToken.exp * 1000);

			if (Date.now() >= expirationDate.getTime()) {
				toast.warn("نشست شما منقضی شده است. لطفا دوباره وارد شوید.");
				localStorage.clear();
				navigate("/login");
				return;
			}
		} else {
			toast.warn("دوباره وارد شوید.");
			localStorage.clear();
			navigate("/login");
			return;
		}

		api
			.post("/editProfile", data, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			})
			.then((res) => {
				toast.success("اطلاعات با موفقیت ویرایش شد");
				dispatch(getAllUserInfo()); // Refresh user data
			})
			.catch((err) => {
				if (err.response && err.response.data && err.response.data.message) {
					toast.error(err.response.data.message);
				} else {
					toast.error("خطا در ویرایش اطلاعات");
				}
			});
	}

	useEffect(() => {
		if (pass.newPass && pass.confirmNewPass === pass.newPass) {
			setDisableBtn(false);
		} else if (pass.newPass && pass.confirmNewPass !== pass.newPass)
			setDisableBtn(true);
		else setDisableBtn(false);
	}, [pass]);

	// Helper function to format price
	const formatPrice = (price) => {
		if (price === 0) return "رایگان";
		return `${price.toLocaleString()} ریال`;
	};

	// Helper function to get current subscription info
	const getCurrentSubscriptionInfo = () => {
		const currentSubscription = userDetail?.subscription;
		if (!currentSubscription) return null;

		const subscription = subscriptions.find(
			(sub) => sub.name === currentSubscription.name,
		);
		return {
			name: currentSubscription.name,
			maxMembers: currentSubscription.max_members,
			startedAt: currentSubscription.started_at,
			transactionSuccessful: currentSubscription.transaction_successful,
			description: subscription?.description || "",
			label: subscription?.label || "starter",
		};
	};

	const currentSubscription = getCurrentSubscriptionInfo();

	// NEW: keep subscriptions in a fixed order (by index / order)
	const orderedSubscriptions = React.useMemo(() => {
		return [...subscriptions].sort((a, b) => a.id - b.id);
	}, [subscriptions]);

	const filteredSubscriptions = React.useMemo(() => {
		return orderedSubscriptions.filter(
			(p) => (p.duration || "monthly") === selectedDuration,
		);
	}, [orderedSubscriptions, selectedDuration]);

	return (
		<div className="editprofile-layout">
			<div className="editprofile-sidebar">
				<UserProfile />
			</div>
			<div className="editprofile-main">
				<div className="editprofile-card">
					<div className="editprofile-userinfo-container">
						<div className="editprofile-userinfo">
							<div
								className={`profile-picture-container${selectedImage ? " image-selected" : ""}`}
							>
								<img
									src={
										imagePreview ||
										getProfilePicture(userDetail.user, profileCircle)
									}
									className="editprofile-usericon"
									alt="User profile"
								/>
								<div
									className={`profile-picture-overlay${selectedImage ? " hide-overlay" : ""}`}
								>
									<label
										htmlFor="profile-picture-input"
										className="profile-picture-upload-btn"
									>
										<Camera size="20" color="#fff" />
									</label>
									<input
										id="profile-picture-input"
										type="file"
										accept="image/*"
										onChange={handleImageSelect}
										style={{ display: "none" }}
									/>
								</div>
								{selectedImage && (
									<div className="profile-picture-actions">
										<button
											className="profile-upload-btn"
											onClick={handleImageUpload}
											disabled={uploadingImage}
										>
											{uploadingImage ? "در حال آپلود..." : "آپلود تصویر"}
										</button>
										<button
											className="profile-cancel-btn"
											onClick={() => {
												setSelectedImage(null);
												setImagePreview(null);
											}}
											disabled={uploadingImage}
										>
											لغو
										</button>
									</div>
								)}
							</div>

							<div className="editprofile-username">
								{userDetail.user?.fname} {userDetail.user?.lname}
							</div>
							<div className="editprofile-useremail">
								{userDetail.user?.email}
							</div>
						</div>
						<div className="editprofile-form-container">
							<h2 className="editprofile-title">ویرایش پروفایل</h2>
							<form
								className="editprofile-form"
								onSubmit={submitForm}
								noValidate
							>
								<div className="form-outline">
									<label>نام</label>
									<input
										type="text"
										className="form-control"
										value={values.fname}
										onChange={(e) =>
											setValues({ ...values, fname: e.target.value })
										}
										required
									/>
								</div>
								<div className="form-outline">
									<label>نام خانوادگی</label>
									<input
										type="text"
										className="form-control"
										value={values.lname}
										onChange={(e) =>
											setValues({ ...values, lname: e.target.value })
										}
										required
									/>
								</div>
								<div className="form-outline">
									<label>نقش</label>
									<input
										type="text"
										className="form-control"
										value={values.role}
										onChange={(e) =>
											setValues({ ...values, role: e.target.value })
										}
										required
									/>
								</div>
								<div className="form-outline">
									<label>رمز عبور</label>
									<input
										type="password"
										className="form-control"
										value={pass.oldPass}
										onChange={(e) =>
											setPass({ ...pass, oldPass: e.target.value })
										}
										required
									/>
								</div>
								<div className="form-outline">
									<label>رمز عبور جدید</label>
									<input
										type="password"
										className="form-control"
										value={pass.newPass}
										onChange={(e) =>
											setPass({ ...pass, newPass: e.target.value })
										}
										required
									/>
								</div>
								<div className="form-outline">
									<label>تکرار رمز عبور جدید</label>
									<input
										type="password"
										className="form-control"
										value={pass.confirmNewPass}
										onChange={(e) =>
											setPass({ ...pass, confirmNewPass: e.target.value })
										}
										required
									/>
								</div>
								<button
									className="editprofile-mobile-btn"
									disabled={disableBtn}
								>
									ذخیره
								</button>
							</form>
							{/* Show mobile verification section only if user doesn't have a verified mobile number */}
							{(!userDetail.user?.mobile || userDetail.user?.mobile === "") && (
								<div className="editprofile-mobile-verify">
									<div className="editprofile-alert">
										<span className="badge badge-warning">!</span>
										لطفا برای تایید شماره موبایل خود اقدام کنید.
									</div>
									<div className="editprofile-mobile-row">
										<input
											className="editprofile-mobile-input"
											type="text"
											placeholder="شماره موبایل خود را وارد کنید."
										/>
										<button className="editprofile-mobile-btn">ارسال کد</button>
									</div>
								</div>
							)}
						</div>
					</div>

					<div className="editprofile-plans-container">
						<div className="editprofile-plan-status">
							<span className="active-plan">
								پلن فعال شما: {currentSubscription?.name || "رایگان"}
							</span>
							<span className="plan-status-info">
								{currentSubscription && (
									<>
										<div className="plan-status-info-item">
											<Timer1
												size="30"
												color="#6B778C"
												variant="Linear"
												style={{ verticalAlign: "middle" }}
											/>
											{currentSubscription.startedAt
												? `شروع شده در ${new Date(currentSubscription.startedAt).toLocaleDateString("fa-IR")}`
												: "اشتراک فعال"}
										</div>
										<div className="plan-status-info-item">
											<Diamonds
												size="30"
												color="#6B778C"
												variant="Linear"
												style={{ verticalAlign: "middle" }}
											/>
											حداکثر {currentSubscription.maxMembers} عضو
										</div>
									</>
								)}
							</span>
						</div>

						<div className="duration-toggle">
							<button
								type="button"
								className={`duration-toggle__btn ${selectedDuration === "monthly" ? "is-active" : ""}`}
								onClick={() => setSelectedDuration("monthly")}
							>
								اشتراک ماهانه
							</button>

							<button
								type="button"
								className={`duration-toggle__btn ${selectedDuration === "yearly" ? "is-active" : ""}`}
								onClick={() => setSelectedDuration("yearly")}
							>
								اشتراک سالانه
							</button>
						</div>
						<div className="editprofile-plans">
							{loadingSubscriptions ? (
								<div className="loading-subscriptions">
									<div className="spinner"></div>
									<p>در حال بارگذاری اشتراک‌ها...</p>
								</div>
							) : (
								filteredSubscriptions.map((plan, index) => (
									<div key={plan.id} className="editprofile-plan-card">
										<div className="plan-title">{plan.name}</div>
										<div className="plan-description">{plan.description}</div>
										<ul className="plan-features">
											{plan.features && plan.features.length > 0 ? (
												plan.features.map((feat, idx) => (
													<li key={idx}>{feat}</li>
												))
											) : (
												<li>اضافه کردن اعضا تا {plan.max_members} نفر</li>
											)}
										</ul>
										<div className="plan-footer">
											<div className="plan-tabs">
												<span className="plan-tab plan-tab-type">
													{plan.label}
												</span>

												{discountAvailable ? (
													// ✅ First time → show discount
													<div className="plan-tab plan-tab-price">
														<div
															className="real-price"
															style={{
																textDecoration: "line-through",
																color: "#c53030",
															}}
														>
															{formatPrice(plan.real_price)}
														</div>
														<div
															className="discounted-price"
															style={{ fontWeight: "bold", fontSize: "1.1rem" }}
														>
															{formatPrice(plan.discounted_price)}
														</div>
													</div>
												) : (
													// ✅ Not first time → only show real price
													<div className="plan-tab plan-tab-price">
														<div
															className="discounted-price"
															style={{ fontWeight: "bold", fontSize: "1.1rem" }}
														>
															{formatPrice(plan.real_price)}
														</div>
													</div>
												)}
											</div>

											<button
												className={`plan-btn ${currentSubscription?.name === plan.name ? "plan-btn-active" : ""}`}
												disabled={
													currentSubscription?.name === plan.name ||
													buyingPlanId === plan.id
												}
												onClick={() => handleBuyPlan(plan)}
											>
												{currentSubscription?.name === plan.name
													? "اشتراک فعال"
													: buyingPlanId === plan.id
														? "در حال انتقال به بانک..."
														: "خرید اشتراک"}
											</button>
										</div>
									</div>
								))
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default EditProfile;
